module.exports = __webpack_public_path__ + "img/battery-half.a02972e8.svg";